import { LABELS } from '@/constants/common/message.constants'
import { type Unpacked } from '@/utils/type-utils'

import { type TruckSpecificationEntity } from '../..'

/**
 * 車両装備 (特殊2)
 */
export type SecondTruckEquipmentType = Unpacked<
  Exclude<TruckSpecificationEntity['secondEquipments'], null>
>

export const SECOND_TRUCK_EQUIPMENT_TYPE = {
  /** パワーゲート (跳ね上げ) */
  POWER_GATE_FLIP_UP: 'POWER_GATE_FLIP_UP',
  /** パワーゲート (格納) */
  POWER_GATE_RETRACTABLE: 'POWER_GATE_RETRACTABLE',
  /** 総輪エアサス */
  ALL_AIR_SUSPENSION: 'ALL_AIR_SUSPENSION',
  /** 後輪エアサス */
  REAR_AIR_SUSPENSION: 'REAR_AIR_SUSPENSION'
} as const satisfies Record<SecondTruckEquipmentType, SecondTruckEquipmentType>

export const SECOND_TRUCK_EQUIPMENT_TYPE_LABEL = {
  [SECOND_TRUCK_EQUIPMENT_TYPE.POWER_GATE_FLIP_UP]: LABELS.POWER_GATE_FLIP_UP,
  [SECOND_TRUCK_EQUIPMENT_TYPE.POWER_GATE_RETRACTABLE]:
    LABELS.POWER_GATE_RETRACTABLE,
  [SECOND_TRUCK_EQUIPMENT_TYPE.ALL_AIR_SUSPENSION]: LABELS.ALL_AIR_SUSPENSION,
  [SECOND_TRUCK_EQUIPMENT_TYPE.REAR_AIR_SUSPENSION]: LABELS.REAR_AIR_SUSPENSION
} as const satisfies Record<SecondTruckEquipmentType, string>
